import React from "react";

const ChevronLeft = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path
      stroke="currentColor"
      d="M16 1L8 12l8 11"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronLeft;



// WEBPACK FOOTER //
// ./src/theme/icons/ChevronLeft.js